const productReducer = (state, action) => {
  switch (action.type) {
    case "update":
      state = state.filter(x => x.parentId !== action.parentId)
      if (action.product) {
        // console.log("NEW PRODUCT STATE", state)
        return [
          ...state,
          {
            ...action.product,
            quantity: action.quantity.toString(),
            parentId: action.parentId,
          },
        ]
      }

      return state
    case "remove":
      // console.log("removing", action.parentId)

      const newState = state.filter(x => x.parentId !== action.parentId)
      // console.log("NEW PRODUCT STATE", newState)

      return newState
    case "resurrect":
      return action.products
    case "reset":
      const softReset = state.filter(
        x =>
          x.parentId === "action-100" ||
          x.parentId === "action-110" ||
          x.parentId === "action-90" ||
          x.parentId === "action-80"
      )
      return softReset
    default:
      break
  }
}

export default productReducer
